import * as React from 'react';
import  { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme, makeStyles, createStyles } from '@mui/styles';
import { Button, Typography } from '@mui/material';
import {Props as definitionSectionProps} from '~common/form/definition-section';
import PortalUserContext from '~common/lib/portal-user-context';
import Renderers from '~common/lib/renderers';
import ProxyFeatureAssignment from '~users/components/proxy-feature-assignment-view'
import EmptySet from "~common/components/empty-set"
import { useState, useContext, createContext } from "react";
import { DataContext } from "~common/form/icg-definition-data-provider";
import { PolicyContext } from "~common/form/icg-definition-data-provider";
import { cloneDeep } from 'lodash'


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            marginBottom: 10,
            paddingLeft: 15
        },
        addNewProxyButton: {
            marginTop: 10
        },
        title: {
            color: "#555", 
            marginBottom: 20
        },
        proxyList: {
            marginLeft: 10
        }
    })
);

interface Props extends React.HTMLProps<HTMLDivElement> {
    history: any;
    match: any;
}

// export const FeatureProxyAssignment: React.FC<Props> = ({
const FeatureProxyAssignment: React.FC<Props> = (props) => {

    const classes = useStyles();

    const [fullData, setFullData] = useContext(DataContext);
    const [policyMessages, setPolicyMessages] = useContext(PolicyContext);

    if (!fullData) {
        return null
    }

    var {proxyInfo} = fullData

    const onProxyChange = (proxy: any) => {

        var _fullData = cloneDeep(fullData)

        if (_fullData.proxyInfo.proxies) {

            if (proxy.id) {
                var proxyIndex = _fullData.proxyInfo.proxies.findIndex((p:any)=>{
                    return p.id == proxy.id
                })
                if (proxyIndex > -1) {
                    _fullData.proxyInfo.proxies[proxyIndex] = proxy
                }   
            }
        
            if (proxy._id) {
                var proxyIndex = _fullData.proxyInfo.proxies.findIndex((p:any)=>{
                    return p._id == proxy._id
                })
                if (proxyIndex > -1) {
                    _fullData.proxyInfo.proxies[proxyIndex] = proxy
                }
            }
        }

        setFullData(_fullData)
    }

    const newProxy = () => {
        var _fullData = cloneDeep(fullData)
        if (_fullData.proxyInfo.proxies) {
            _fullData.proxyInfo.proxies.push({_id: new Date().getTime(), portalUserID: PortalUserContext.userContext.id, extendedAttributes: {}})
            setFullData(_fullData)
        }
    }

    if (!proxyInfo || !proxyInfo.features || (proxyInfo.features && proxyInfo.features.length == 0)) {
        return null
    }

    proxyInfo.proxies.forEach((p:any)=>{
      
      if (p.id == 0) {
        p.id = undefined
      }

      if (policyMessages && policyMessages.length > 0) {
        
        policyMessages.forEach((pm:any)=>{
          var policyIndex
          if (pm.path.indexOf("/proxyInfo/proxies") > -1) {
            var parts = pm.path.split("/")
            policyIndex = parts[parts.length-1]
          }
          if (policyIndex) {
            proxyInfo.proxies[policyIndex]._proxyToUserIDMissing = true
          }
        })
      }

    })

    return (
        <div className={classes.container}>

                <Typography className={classes.title} variant="h6" >Proxies</Typography>

                <div className={classes.proxyList}>
                    {proxyInfo.proxies && proxyInfo.proxies.map((p:any, idx)=>{
                        return (
                            <ProxyFeatureAssignment userType={PortalUserContext.userContext.userType} idx={idx} key={idx} proxy={p} proxies={proxyInfo.proxies} features={proxyInfo.features} onProxyChange={onProxyChange}></ProxyFeatureAssignment>
                        )
                    })}
                </div>
                

                {!proxyInfo.proxies || proxyInfo.proxies.filter((p: any) => { return !p.extendedAttributes["_delete"] }).length == 0 &&
                    <EmptySet classes={{}} text="No proxies have been provided" />
                }

                <Button
                    variant="contained"
                    color="primary"
                    className={classes.addNewProxyButton}
                    onClick={newProxy}
                    disabled={false}
                    >
                    Add New
                </Button>
        </div>
    )
}

FeatureProxyAssignment.register = () => {
    if (!Renderers.find("proxyAssignmentView")) {
        Renderers.register("proxyAssignmentView", FeatureProxyAssignment);
    }
}

export default FeatureProxyAssignment;